import { Badge, SxProps, Theme } from "@mui/material"
import { ElementType, HTMLAttributes, ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface ElementProps extends HTMLAttributes<HTMLDivElement> {
    icon?: ElementType,
    badge?: ElementType,
    badgeSx?: SxProps<Theme>,
    badgeMarker?: any,
    sxProps?: SxProps<Theme>,
    colorProp?: string,
    sizeProp?: string,
    children?: ReactNode
}

export function Element({
    icon: Icon,
    badge: BadgeIcon,
    badgeSx,
    badgeMarker,
    colorProp,
    sxProps,
    sizeProp,
    children,
    ...rest
}: ElementProps) {
    return (
        <div className={twMerge("", rest.className)}>
            <Badge badgeContent={BadgeIcon ? <BadgeIcon /> : badgeMarker} sx={badgeSx}
                overlap="circular" anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                {Icon ? <Icon sx={sxProps} color={colorProp} fontSize={sizeProp} /> : children}
            </Badge>
        </div>
    )
}